<template>
<div class="chapter">
<div class="inner_page">
<h1>Prologue</h1>
<p class="sectiontop"><b>October 4, 1983<br/>
  Dallas, Texas</b></p>
<p class="first">Peter Gailiunas was chatting with his mother when the conversation was interrupted by the familiar but irritating click that told him someone else was trying to get through to his number.</p>
<p>“I have to get that, Mother,” he said. “Hold on for a minute.”</p>
<p>He depressed the plunger to switch to the incoming call and spoke into the mouthpiece.</p>
<p>“Yes,” he said sharply, “this is Dr. Gailiunas.”</p>
<p>“Hi, Dad,” squeaked a familiar voice. “Where are you?”</p>
<p>Gailiunas sighed in relief. It was his four-and-a-half-year-old son, Peter Gailiunas III, commonly called Little Peter.</p>
<p>“I’m at home,” Gailiunas said, looking at his watch. It was 6:15 <span class="small">P</span>.<span class="small">M</span>. “You should be here,” he scolded. “You’re late. Where’s Mom?”</p>
<p>“She’s sleeping,” Little Peter replied.</p>
<p>“<i>You</i> didn’t call me, did you?” Gailiunas said, doubting that the boy knew how to operate a telephone, much less that he could remember the phone number.</p>
<p>“Yes,” Little Peter replied proudly.</p>
<p>“I didn’t know you knew how to dial,” the doctor said with no little amount of affection. “Go get Mom.”</p>
<p>Gailiunas drummed his fingers, waiting for his son to summon his mother.</p>
<p>Little Peter was back on the line in less than two minutes. “I can’t wake her up,” he said. “She’s sleeping.”</p>
<p>Gailiunas frowned. “Go back and try again,” he said.</p>
<p>For the second time, Little Peter returned and said he still was unable to awaken her.</p>
<p>Gailiunas, annoyed, urged him to try yet again.</p>
<p>“I really can’t wake her up, Dad,” the boy said after the third attempt. “She’s sick.”</p>
<p>Gailiunas’s exasperation turned to concern. “What do you mean, ‘sick’?” he asked.</p>
<p>“She’s really sick,” Little Peter said. “There’s green stuff coming out of her mouth.”</p>
<p>Gailiunas tensed. “Are you okay?” he asked abruptly.</p>
<p>“Yes,” replied Little Peter.</p>
<p>“Is anyone in the house?”</p>
<p>“No.”</p>
<p>“Then lock the door,” Gailiunas ordered, “and don’t let anyone in. Daddy will be there.”</p>
<p>Less than thirty minutes later the phone rang in the house where Little Peter lived with his mother. The boy answered it on the second ring.</p>
<p>“Hello,” he whispered uncertainly.</p>
<p>“Hello, Peter,” a man’s voice replied. “This is Larry Aylor. Let me speak to your mom.”</p>
<p>“She’s sick,” said the boy.</p>
<p>“Where is she?” Aylor asked.</p>
<p>“In bed.”</p>
<p>“Go get her,” Aylor instructed. “She’ll want to talk to me.”</p>
<p>“I can’t,” the boy replied. “She’s sick bad.”</p>
<p>Aylor opened his mouth, intending to insist, when he heard a man’s voice in the background.</p>
<p>“Hang up the goddamn phone!” the man screamed.</p>
<p>Before Aylor could respond, the line went dead.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_prologue.vue?3313eb7a